import type { IconButtonProps } from '@src/shared/ui/Button';
import { ArrowRightIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import NavIconButton from './NavIconButton';

const NextIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <NavIconButton ref={ref} {...props}>
        <ArrowRightIcon />
      </NavIconButton>
    );
  },
);

export default NextIconButton;
